<template>
  <div class="board">
    <div>
      <div class="flex flex-row text-gray-300 font-bold justify-center">
        <button @click="lastWeek()" class="mb-4">BACK</button>
        <div class="mx-8 mb-4">WEEK {{ week }}</div>
        <button @click="nextWeek()" class="mb-4">FORWARD</button>
      </div>
    </div>
    <div class="flex flex-row items-start justify-center">
      <div class="column">
        <v-select
          label="name"
          @input="setActiveUser"
          :value="$store.activeUser"
          :options="users"
          placeholder="Select a Family Member"
          class="user-dropdown mb-2"
        ></v-select>
        <div class="list-reset">
          <div
            class="goal bg-gray-300"
            v-for="(goal, $goalIndex) of goals
              .filter(goal => goal.week === week)
              .filter(goal => goal.userID === activeUser.id)"
            :key="$goalIndex"
            @click="goToGoal(goal)"
          >
            <span class="w-11/12 flex-no-shrink font-bold">
              {{
              goal.area
              }}
            </span>
            <button @click.stop="deleteGoal(goal)" class="bg-red-800 text-white rounded-full px-2">x</button>
            <p v-if="goal.expected" class="w-full flex-no-shrink mt-1 text-sm">{{ goal.expected }}</p>
          </div>
          <input
            type="text"
            class="block p-2 w-full bg-transparent placeholder-teal-800 font-bold"
            placeholder="+ Enter new goal area (then click to edit)"
            @keyup.enter="createGoal($event, goals, activeUser.id, week)"
          />
        </div>
      </div>
    </div>

    <div class="goal-bg" v-if="isGoalOpen" @click.self="close">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  mounted() {
    this.$store.dispatch("fetchGoals");
  },
  computed: {
    ...mapState(["users", "goals", "week", "activeUser"]),
    isGoalOpen() {
      return this.$route.name === "goal";
    }
  },
  methods: {
    goToGoal(goal) {
      this.$router.push({ name: "goal", params: { id: goal.goalID } });
    },
    close() {
      this.$router.push({ name: "goal-board" });
    },
    createGoal(e, goals, userID, week) {
      this.$store.dispatch("createGoal", {
        goal: {
          goalID: "",
          area: e.target.value,
          userID,
          week,
          actual: "",
          expected: ""
        }
      });
      e.target.value = "";
    },
    deleteGoal(goal) {
      this.$store.dispatch("deleteGoal", goal);
    },
    nextWeek() {
      this.$store.commit("NEXT_WEEK");
    },
    lastWeek() {
      this.$store.commit("LAST_WEEK");
    },
    setActiveUser(user) {
      this.$store.commit("SET_ACTIVE_USER", user);
    }
  }
};
</script>

<style lang="css">
.goal {
  @apply flex items-center flex-wrap shadow mb-2 py-2 px-2 rounded bg-white text-gray-800 no-underline;
}

.column {
  @apply bg-gray-500 p-2 mx-2 text-left rounded-lg shadow-2xl w-1/2;
  min-width: 350px;
}

.board {
  @apply p-6 bg-gray-700 h-full overflow-auto;
}

.goal-bg {
  @apply pin absolute;
  background: rgba(0, 0, 0, 0.5);
}

.pin {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.user-dropdown .vs__search::placeholder,
.user-dropdown .vs__dropdown-toggle,
.user-dropdown .vs__active,
.user-dropdown .vs__selected,
.user-dropdown .vs__dropdown-menu {
  text-transform: lowercase;
  font-variant: small-caps;
  font-weight: bold;
}
</style>
